import SeminarSpeaker, { SeminarSpeakerProps } from './SeminarSpeaker.component';

export type SeminarSpeakerType = SeminarSpeakerProps;

export default SeminarSpeaker;
